@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .root {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }

  .labelText {
    @include typography-v2-body-sm;
    color: var(--text-soft);
    white-space: nowrap;

    &.labelSolid {
      color: var(--text-default);
    }
  }

  .icon {
    fill: var(--icon-on-primary);
    transition: opacity 0.3s ease;
    opacity: 0;

    &.iconVisible {
      opacity: 1;
    }
  }

  .toggleInput {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;

    &:focus-visible + .container {
      outline: 1px solid var(--border-focus);
    }
  }

  .container {
    display: flex;
    align-items: center;
    position: relative;
    background-color: var(--surface-neutral);
    transition: background-color 0.3s ease;
    border-radius: 32px;

    &.medium {
      height: 24px;
      width: 44px;
    }

    &.small {
      height: 18px;
      width: 32px;
    }

    &.backgroundActive,
    &.checked {
      background-color: var(--surface-primary);
    }
  }

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    border-radius: 20px;
    left: 2px;
    background-color: var(--surface-white);
    transition: transform 0.3s ease;
    transform: translateX(0);

    &.circleMedium {
      height: 20px;
      width: 20px;
    }

    &.circleSmall {
      height: 14px;
      width: 14px;
    }

    &.circleChecked {
      transform: translateX(100%);
    }
  }
}
